import { css } from '@/styled-system/css';

export const triggerTextStyles = css.raw({
  display: 'inline-flex',
  color: 'inherit',
  cursor: 'pointer',
  fontFamily: 'inherit',
  fontSize: 'inherit',
  fontWeight: 'inherit',
  userSelect: 'text',
  padding: 'none',
  textDecorationLine: 'underline',
  textDecorationStyle: 'dashed',
  textDecorationThickness: '{borderWidths.default}',
  textDecorationColor: 'TriggerText.border.default',
  textDecorationSkipInk: 'none',
  textUnderlineOffset: '0.25lh',

  _focusVisible: {
    boxShadow: 'focus',
  },

  _hover: {
    textDecorationColor: 'TriggerText.border.hover',
  },

  _active: {
    textDecorationColor: 'TriggerText.border.pressed',
  },
});
